<template>
  <v-container fill-height pa-0>
    <v-layout>
      <v-container class="justify">
        <v-flex xs12 mb-2>
          <span class="hidden-sm-and-up">Welcome, {{ username }}</span>
          <v-spacer></v-spacer>
          <span>{{ months[getDate.getMonth()] }} {{ getDate.getDate() }}, {{getDate.getFullYear()}}</span>
        </v-flex>

        <v-card flat color="merch" class="pa-2 ma-auto merchant-header">
          <div class="mt-0 pa-0 pr-2">
            <h3 class="font-weight-regular" v-text="merchantLocation.merchant_name"></h3>
            <h4 class="font-weight-light" v-text="merchantLocation.address"></h4>
          </div>
        </v-card>
        <v-expansion-panel expand v-model="panel">
          <v-expansion-panel-content>
            <div slot="header">
              <h3 class="font-weight-regular">Merchant Details</h3>
              <h5 class="font-weight-light">Merchant Name, phone, ...</h5>
            </div>
            <v-form ref="form" v-model="valid" @submit.prevent="submit">
              <v-card>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 sm6 pa-2>
                      <label class="pt-3">Merchant Name</label>
                      <v-text-field
                        class="width70"
                        solo
                        v-model="updatedMerchant.name"
                        label="Merchant Name"
                        :disabled="!is_update.personal"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 pa-2>
                      <label class="pt-3">Phone No</label>
                      <v-text-field
                        class="width70"
                        solo
                        v-model="updatedMerchant.phone"
                        label="Phone number"
                        :disabled="!is_update.personal"
                      ></v-text-field>
                    </v-flex>
                    <!-- <v-flex xs12 sm6 pa-2>
                      <label class="pt-3">Category</label>
                      <v-select
                        class="width70"
                        solo
                        v-model="updatedMerchant.category"
                        :items="categories"
                        item-text="name"
                        item-value="value"
                        :disabled="!is_update.personal"
                      ></v-select>
                    </v-flex> -->
                    <v-flex xs12 sm6 pa-2>
                      <label class="pt-3">Business Type</label>
                      <v-autocomplete
                        class="width70"
                        solo
                        v-model="updatedMerchant.business_type"
                        :items="businessTypes"
                        item-text="rep"
                        item-value="id"
                        :disabled="!is_update.personal"
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 justify-end>
                      <v-btn
                        @click="is_update.personal=true"
                        v-if="!is_update.personal"
                        color="accent darken-2"
                        dark
                      >Update Details</v-btn>
                      <div v-if="is_update.personal" class="d-inline-block">
                        <v-btn @click="is_update.personal=false" flat color="error" dark>Cancel</v-btn>
                        <v-btn @click="updateMerchant" color="primary" dark>Update</v-btn>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-form>
          </v-expansion-panel-content>
          <v-expansion-panel-content>
            <div slot="header">
              <h3 class="font-weight-regular">Location Details</h3>
              <h5 class="font-weight-light">Address, Route, ...</h5>
            </div>
            <v-form ref="form" v-model="valid" @submit.prevent="submit">
              <v-card>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 sm6 pa-2>
                      <label class="pt-3">Address</label>
                      <v-textarea
                        class="width70"
                        solo
                        v-model="updatedLocation.address"
                        label="Merchant Address"
                        :disabled="!is_update.location"
                      ></v-textarea>
                    </v-flex>
                    <!-- <v-flex xs12 sm6 pa-2>
                      <label class="pt-3">Route</label>
                      <v-text-field
                        class="width70"
                        solo
                        v-model="updatedLocation.route"
                        :disabled="!is_update.location"
                      ></v-text-field>
                    </v-flex> -->
                    <v-flex xs12 sm6 pa-2>
                      <label class="pt-3">Attendant Name</label>
                      <v-text-field
                        class="width70"
                        solo
                        v-model="updatedLocation.attendant_name"
                        label="Attendant Name"
                        :disabled="!is_update.location"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 pa-2>
                      <label class="pt-3">Attendant Phone</label>
                      <v-text-field
                        class="width70"
                        solo
                        v-model="updatedLocation.attendant_phone"
                        label="Attendant Number"
                        :disabled="!is_update.location"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 justify-end>
                      <v-btn
                        @click="is_update.location=true"
                        v-if="!is_update.location"
                        color="accent darken-2"
                        dark
                      >Update Details</v-btn>
                      <div v-if="is_update.location" class="d-inline-block">
                        <v-btn @click="is_update.location=false" flat color="error" dark>Cancel</v-btn>
                        <v-btn @click="updateLocation" color="primary" dark>Update</v-btn>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-form>
          </v-expansion-panel-content>
          <v-expansion-panel-content>
            <div slot="header">
              <h3 class="font-weight-regular">Terminal Details</h3>
              <h5 class="font-weight-light">Terminal Ids, serial No, ...</h5>
            </div>

            <v-form ref="form" v-model="valid" @submit.prevent="submit">
              <v-card>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 sm6 pa-2>
                      <label class="pt-3">Terminal ID</label>
                      <v-select
                        class="width70"
                        solo
                        label="Terminal Id"
                        :value="terminal_ids[tid_no]"
                        @change="changeTid"
                        :items="terminal_ids"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm6 pa-2>
                      <label class="pt-3">Serial No</label>
                      <v-text-field
                        class="width70"
                        solo
                        label="Serial number"
                        v-model="updatedTerminal.serial_no"
                        :disabled="!is_update.terminal"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6 pa-2>
                      <label class="pt-3">Merchant ID</label>
                      <v-text-field
                        class="width70"
                        solo
                        label="Merchant ID"
                        v-model="updatedTerminal.merchant_uuid"
                        :disabled="!is_update.terminal"
                      ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm6 pa-2>
                      <label class="pt-3">Bank</label>
                      <v-autocomplete
                        class="width70"
                        solo
                        v-model="updatedTerminal.bank"
                        :items="banks"
                        item-text="name"
                        item-value="id"
                        :disabled="!is_update.terminal"
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm6 pa-2>
                      <label class="pt-3">PoS Type</label>
                      <v-autocomplete
                        class="width70"
                        solo
                        v-model="updatedTerminal.terminal_type"
                        :items="terminalTypes"
                        item-text="rep"
                        item-value="id"
                        :disabled="!is_update.terminal"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm6 pa-2>
                      <label class="pt-3">App on PoS</label>
                      <v-autocomplete
                        class="width70"
                        solo
                        v-model="updatedTerminal.terminal_app"
                        :items="terminalApps"
                        item-text="rep"
                        item-value="id"
                        :disabled="!is_update.terminal"
                      ></v-autocomplete>
                    </v-flex>

                    <!-- <v-flex xs12 sm6 pa-2>
                                                <label class="pt-3">SIM Type</label>
                                                <v-select
                                                    class="width70"
                                                    solo
                                                    v-model="updatedLocation.sim"
                                                    :items="dataProvider"
                                                ></v-select>
                    </v-flex>-->
                    <v-flex xs12 justify-end>
                      <v-btn
                        @click="is_update.terminal=true"
                        v-if="!is_update.terminal"
                        color="accent darken-2"
                        dark
                      >Update Details</v-btn>
                      <div v-if="is_update.terminal" class="d-inline-block">
                        <v-btn @click="is_update.terminal=false" flat color="error" dark>Cancel</v-btn>
                        <v-btn @click="updateTerminal" color="primary" dark>Update</v-btn>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-form>
          </v-expansion-panel-content>
          <v-expansion-panel-content>
            <div slot="header">
              <h3 class="font-weight-regular">Status Report</h3>
              <h5 class="font-weight-light">Give feedback on terminal...</h5>
            </div>
            <v-form ref="form" v-model="valid" @submit.prevent="submit">
              <v-card>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 sm6 pa-2>
                      <label class="pt-3">Comment</label>
                      <v-autocomplete
                        class="width70"
                        v-model="report.comment"
                        solo
                        label="Comment"
                        @change="changeStatus"
                        :items="comments"
                        item-text="name"
                        item-value="value"
                      ></v-autocomplete>
                    </v-flex>

                    <!-- Accessible -->
                    <v-flex v-if="status[0].show" xs12 sm6 pa-2>
                      <label class="pt-3">Remark</label>
                      <v-autocomplete
                        class="width70"
                        v-model="report.remark"
                        solo
                        label="Remark"
                        :items="remarks"
                        item-text="name"
                        item-value="value"
                      ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 v-if="status[0].show">
                      <v-layout row wrap>
                        <v-flex xs12 sm6 pa-2 v-if="report.remark == 'Other'">
                          <label class="pt-3">New Remark</label>
                          <v-textarea
                            class="width70"
                            v-model="report.further_remark"
                            solo
                            type="text"
                            label="Enter new remark"
                          ></v-textarea>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          pa-2
                          v-if="report.remark == 'WORKING_SUCCESSFUL' || report.remark == 'WORKING_BUT_NOT_IN_USE' || report.remark == 'INSUFFICIENT_FUNDS'"
                        >
                          <label class="pt-3">Data Provider</label>
                          <v-autocomplete
                            class="width70"
                            v-model="report.data_providers"
                            solo
                            label="Data Provider"
                            :items="dataProviders"
                            item-text="name"
                            item-value="value"
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          pa-2
                          v-if="report.remark == 'WORKING_SUCCESSFUL' || report.remark == 'WORKING_BUT_NOT_IN_USE'"
                        >
                          <label class="pt-3">Ref No</label>
                          <v-text-field
                            class="width70"
                            v-model="report.tx_ref"
                            solo
                            type="number"
                            label="Reference no"
                          ></v-text-field>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          pa-2
                          v-if="report.remark == 'WORKING_SUCCESSFUL' || report.remark == 'WORKING_BUT_NOT_IN_USE'"
                        >
                          <label class="pt-3">Amount</label>
                          <v-select
                            class="width70"
                            v-model="report.tx_amount"
                            solo
                            type="text"
                            label="Amount"
                            :items="tx_amt_fixed"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 sm6 pa-2 v-if="report.tx_amount == 'Other'">
                          <label class="pt-3">New Amount</label>
                          <v-text-field
                            class="width70"
                            v-model="report.tx_other"
                            solo
                            type="text"
                            label="Enter Amount"
                          ></v-text-field>
                        </v-flex>
                        <v-flex v-if="report.remark" xs12 sm6 pa-2>
                          <label class="pt-3">Items</label>
                          <v-select
                            class="width70"
                            v-model="report.item_name"
                            solo
                            label="Items given(if any)"
                            :items="itemTypes"
                            item-text="name"
                            item-value="value"
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 sm6 pa-2 v-if="report.item_name">
                          <label class="pt-3">Quantity</label>
                          <v-text-field
                            class="width70"
                            v-model="report.item_quantity"
                            type="number"
                            solo
                            label="Quantity given"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <!-- Inaccessible -->
                    <v-flex xs12 sm6 pa-2 v-if="status[1].show">
                      <label class="pt-3">Reason(s)</label>
                      <v-textarea
                        class="width70"
                        v-model="report.further_remark"
                        solo
                        type="text"
                        label="Reason why Terminal(s) are inaccessible"
                      ></v-textarea>
                    </v-flex>

                    <!-- TID not found -->
                    <v-flex xs12 sm6 pa-2 v-if="status[2].show">
                      <label class="pt-3">Available TID</label>
                      <v-text-field
                        class="width70"
                        v-model="report.further_remark"
                        solo
                        type="text"
                        label="Available TID(if any)"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-flex class="justify mb-2">
                    <v-btn
                      type="submit"
                      class="text-xs-align"
                      color="primary"
                      :loading="submitLoading"
                      :disabled="!valid && submitLoading"
                    >SUBMIT</v-btn>
                  </v-flex>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import AppLayout from "../../layouts/app"
import utils from "@/common/utils"
import axios from "axios"
import { mapGetters, mapState } from "vuex"
import { SUBMIT_REPORT } from "@/store/actions/marshal"
import {
  FETCH_MERCHANT,
  UPDATE_MERCHANT,
  UPDATE_MERCHANT_LOCATION,
  UPDATE_TERMINAL
} from "@/store/actions/merchant"

export default {
  name: "FeedbackPage",
  data() {
    return {
      getDate: new Date(),
      valid: false,
      tid_no: 0,
      submitLoading: false,
      panel: [false, false, true, true],
      status: [
        { name: "a", show: false },
        { name: "i", show: false },
        { name: "tn", show: false }
      ],
      is_update: {
        personal: false,
        location: false,
        terminal: false
      },
      report: {
        terminal: "",
        merchant_location: "",
        comment: "",
        remark: "",
        further_remark: "",
        data_providers: "",
        item_name: "",
        item_quantity: 0,
        location: "",
        tx_ref: "",
        tx_amount: 0.0,
        tx_other: 0.0
        // inaccessible: "",
        // tidnotfound: "",
        // newlocation: "",
      },
      amtTypes: [0.12, 1.0]
    }
  },
  computed: {
    ...mapState({
      username: state => state.user.profile.first_name,
      merchant: state => state.merchant.merchant,
      banks: state => state.common.banks,
      businessTypes: state => state.common.businessTypes,
      terminalTypes: state => state.common.terminalTypes,
      terminalApps: state => state.common.terminalApps
    }),
    ...mapGetters({
      getMerchantLocationById: "getMerchantLocationById"
    }),
    updatedMerchant: function() {
      return { ...this.merchant }
    },
    updatedLocation: function() {
      return { ...this.merchantLocation }
    },
    updatedTerminal: function() {
      return { ...this.updatedLocation.terminals[this.tid_no] }
    },
    merchantLocation: function() {
      return this.getMerchantLocationById(this.$route.params.location_id)
    },
    // categories: function() {
    //     return utils.CATEGORY_CHOICES
    // },
    comments: function() {
      return utils.COMMENT_CHOICES
    },
    months: function() {
      return utils.MONTH_CHOICES
    },
    remarks: function() {
      return utils.REMARK_CHOICES
    },
    itemTypes: function() {
      return utils.ITEM_CHOICES
    },
    dataProviders: function() {
      return utils.DATA_PROVIDERS
    },
    terminal_ids: function() {
      return this.merchantLocation.terminals.map(
        terminal => terminal.terminal_uuid
      )
    },
    tx_amt_fixed: function() {
      let new_amt = []
      this.amtTypes.forEach((element, index) => {
        new_amt.push(element.toFixed(2))
      })
      new_amt.push("Other")
      return new_amt
    }
  },
  methods: {
    changeTid(tid) {
      this.terminal_ids.forEach((element, index) => {
        if (element == tid) {
          this.tid_no = index
        }
      })
    },
    changeStatus(a) {
      this.status.forEach((element, index) => {
        element.show = false
        if (element.name == a) {
          element.show = true
        }
      })
    },
    updateMerchant() {
      if (this.$refs.form.validate()) {
        console.log(this.updatedMerchant)
        this.$store.dispatch(UPDATE_MERCHANT, this.updatedMerchant).then(() => {
          // Show form submitted toast
        })
      }
      this.is_update.personal = false
    },
    updateLocation() {
      if (this.$refs.form.validate()) {
        let locationNotChanged = this.updatedLocation.address === this.merchantLocation.address
          && this.updatedLocation.attendant_name === this.merchantLocation.attendant_name
          && this.updatedLocation.attendant_phone === this.merchantLocation.attendant_phone
        if (!locationNotChanged) {
          this.$store
            .dispatch(UPDATE_MERCHANT_LOCATION, this.updatedLocation)
            .then(() => {
              // Show form submitted toast
            })
        }
      }
      this.is_update.location = false
    },
    updateTerminal() {
      if (this.$refs.form.validate()) {
        console.log(this.updatedTerminal)
        this.$store.dispatch(UPDATE_TERMINAL, this.updatedTerminal).then(() => {
          // Show form submitted toast
        })
      }
      this.is_update.terminal = false
    },
    async submit() {
      if (this.$refs.form.validate()) {
        const online = navigator.onLine
        this.submitLoading = true
        this.report.merchant_location = this.updatedLocation.id
        this.report.terminal = this.updatedTerminal.id
        if (navigator.geolocation) {
          await navigator.geolocation.getCurrentPosition(async position => {
            const coords = {
              lat: position.coords.latitude,
              long: position.coords.longitude
            }
            const url = "https://maps.googleapis.com/maps/api/geocode/json"
            const apiKey = "AIzaSyCEVkk-kDc6Nrzp652YvpUSPKNjYMhJnCo"
            // let resp = await axios.get(`${url}?latlng=${coords.lat},${coords.long}&key=${apiKey}`)
            // this.report.location = resp.data.results[0].formatted_address
            this.report.location = `${coords.lat},${coords.long}`
            this.$store.dispatch(SUBMIT_REPORT, this.report).then(() => {
              // Show form submitted toast
              this.submitLoading = false
              if (online) {
                console.log("online")
                utils.showSnackbar({message:'Report submitted', color: 'green'})
              } else {
                utils.showSnackbar({message:'You are offline, Report will be submitted when you come online'})
              }
              this.$refs.form.reset()
            }).catch(err => {
              // display notification with errors
              utils.showSnackbar({message:`Error: ${err.message}`, color: 'red'})
              this.submitLoading = false
            })
          }, async error => {
            console.log("in error")
            utils.showSnackbar({message:`Please turn on your location`, color: 'red'})
            this.submitLoading = false
          }, { timeout: 10 * 1000 })
        } else {
          // Display notification: Please turn on location and try again
          console.log("Geolocation is not supported by this browser.")
          this.submitLoading = false
        }
      }
    }
  },
  created() {
    this.$emit("update:layout", AppLayout)
  },
  mounted() {
    this.$store.dispatch(FETCH_MERCHANT, this.merchantLocation.merchant)
  }
}
</script>

<style scoped>
.merchant-header {
  background: rgba(0, 0, 0, 0.1)
}

.width70 {
  width: 60%
}

label {
  width: 25%
}

.justify {
  justify-content: center
}

hr {
  width: 95%;
  border-color: rgba(0, 0, 0, 0.1);
  margin: auto
}
</style>

